import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { KeyboardArrowDown } from "@material-ui/icons";
import { KeyboardArrowUp } from "@material-ui/icons";

const HideShowMileStoneButtton = props => {
  const { onMilestoneButtonClick } = props;

  const [showPhaseOnBucketComplete, setshowPhaseOnBucketComplete] = useState(
    false
  );

  const onClickOfShowMilestone = () => {
    setshowPhaseOnBucketComplete(!showPhaseOnBucketComplete);
    onMilestoneButtonClick(showPhaseOnBucketComplete);
  };

  return (
    <Button
      className="add-phase-btn hide-show-btn btn btn-primary"
      onClick={onClickOfShowMilestone}
    >
      {!showPhaseOnBucketComplete ? (
        <>
          Show Milestones <KeyboardArrowDown />{" "}
        </>
      ) : (
        <>
          Hide Milestones <KeyboardArrowUp />{" "}
        </>
      )}
    </Button>
  );
};
export default HideShowMileStoneButtton;
